import { Tooltip } from 'bootstrap';
export const registerMixins = (app) => {
    app.mixin({
        methods: {
            isDefined(obj) {
                return ((typeof obj !== 'undefined') && (obj !== null));
            },
            formatNumber(value, precision) {
                return (parseFloat(value).toFixed(precision || 0)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','));
            },
            formatCurrency(value) {
                if (typeof value !== 'number') {
                    return value;
                }
                return ('$' + parseFloat(value).toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','));
            },
            isUndefinedOrEmpty(obj) {
                return ((typeof obj === 'undefined') || (obj === null)
                    || ((typeof obj === 'string') && (!obj.trim())));
            },
            getBoolean(value) {

                if (typeof value == "string") {
                    value = value.toLowerCase();
                }
                switch (value) {
                    case true:
                    case "true":
                    case 1:
                    case "1":
                    case "on":
                    case "yes":
                        return true;
                    default:
                        return false;
                }
            },
            scrollToTop() {
                document.querySelector('body').scrollIntoView({behavior: 'smooth'});
            },
            sanitizeValueForAttribute(value) {
                return value.toLowerCase().replace(/\s+/, '-').replace(/[^A-Za-z0-9\_\-]/, '');
            },
            compareIntOrString(a, b) {
                if (typeof a === typeof b) {
                    return a === b
                } else {
                    a = typeof a === 'number' ? a.toString() : a;
                    b = typeof b === 'number' ? b.toString() : b;
                    return a === b
                }
            },
            /*scrollToFirstError() {
                var firstErrorEle = this.$el.querySelector('.has-error');
                if(firstErrorEle) {
                    firstErrorEle.scrollIntoView({behavior: 'smooth'});
                }
            }*/
        }
    });

    app.config.globalProperties.$filters = {
        toCurrency(value) {
            if (!value) {
                return value;
            }
            return ('$' + parseFloat(value).toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ','));
        }
    }

    app.directive('tooltip', {
        beforeMount(el, binding, vnode) {
            new Tooltip(el, {
                title: el.querySelector('.help-text').innerHTML,
                html: true,
                placement: 'top',
                trigger: 'hover focus'
            });
        }
    });

    /// https://github.com/MeForma/vue-copy-to-clipboard/blob/main/index.js
    app.config.globalProperties.$copyText = (text) => {
        if (!navigator.clipboard) {
            const textArea = document.createElement('textarea')
            textArea.value = text

            textArea.style.top = '0'
            textArea.style.left = '0'
            textArea.style.position = 'fixed'

            document.body.appendChild(textArea)
            textArea.focus()
            textArea.select()

            try {
                document.execCommand('copy')
                document.body.removeChild(textArea)
                return Promise.resolve()
            } catch (err) {
                document.body.removeChild(textArea)
                return Promise.reject(err)
            }
        }

        return navigator.clipboard.writeText(text)
    };

}
